import React from 'react';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';

import StyledQRCode from 'app/components/flat/ui/StyledQRCode';

import { useModalPaymentLinkPixBootstrap } from './modalPaymentLinkPix.bootstrap.hook';
import { ModalDialog, ModalOverlay } from '../styles';
import { ISubmitPaymentLinkOneTimePayment } from '../types/types';
import {
  ConfirmButton,
  CopyButton,
  DeadlineNotice,
  Description,
  IconWrapper,
  QRCodeWrapper,
  Title,
} from './style';

interface ModalPaymentLinkPixProps {
  open: boolean;
  data?: ISubmitPaymentLinkOneTimePayment;
  onClose: () => void;
}

export const ModalPaymentLinkPix: React.FC<ModalPaymentLinkPixProps> = ({
  open,
  data,
  onClose,
}) => {
  const { copied, handleCopyCode, canCopy, expiresAtLabel } =
    useModalPaymentLinkPixBootstrap(data);

  return (
    <ModalOverlay $open={open}>
      <ModalDialog>
        <IconWrapper>
          <QrCode2OutlinedIcon />
        </IconWrapper>

        <Title>Pague com Pix</Title>
        <Description>
          Escaneie o QR Code ou copie o código abaixo e cole no app do seu
          banco. Seu pagamento será aprovado em alguns instantes.
        </Description>

        <QRCodeWrapper>
          {data?.qrCodeUrl ? (
            <img src={data.qrCodeUrl} alt="QR Code Pix" />
          ) : (
            <StyledQRCode value={data?.qrCode} size={220} />
          )}
        </QRCodeWrapper>

        <CopyButton onClick={handleCopyCode} disabled={!canCopy}>
          {copied ? 'Copiado!' : 'Copiar código'}
        </CopyButton>

        {expiresAtLabel && (
          <DeadlineNotice>Expira em {expiresAtLabel}</DeadlineNotice>
        )}

        <ConfirmButton type="button" onClick={onClose}>
          Entendi
        </ConfirmButton>
      </ModalDialog>
    </ModalOverlay>
  );
};

export default ModalPaymentLinkPix;
